// extracted by css-extract-rspack-plugin
export default {"historyHeader":"src-components-Widgets-DeviceGroupWidget-module__historyHeader-bHamoD","historyChevron":"src-components-Widgets-DeviceGroupWidget-module__historyChevron-dwr0eR","historyChevronExpanded":"src-components-Widgets-DeviceGroupWidget-module__historyChevronExpanded-xgwpf4"};
    if(module.hot) {
      (function() {
        var localsJsonString = "{\"historyHeader\":\"src-components-Widgets-DeviceGroupWidget-module__historyHeader-bHamoD\",\"historyChevron\":\"src-components-Widgets-DeviceGroupWidget-module__historyChevron-dwr0eR\",\"historyChevronExpanded\":\"src-components-Widgets-DeviceGroupWidget-module__historyChevronExpanded-xgwpf4\"}";
        // 1790730173034
        var cssReload = require("../../../node_modules/@rspack/core/dist/cssExtractHmr.js").cssReload(module.id, {});
        // only invalidate when locals change
        if (
          module.hot.data &&
          module.hot.data.value &&
          module.hot.data.value !== localsJsonString
        ) {
          module.hot.invalidate();
        } else {
          module.hot.accept();
        }
        module.hot.dispose(function(data) {
          data.value = localsJsonString;
          cssReload();
        });
      })();
    }
  